import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import { convertToBulletPoints, formatTechnologies, formatDateRange } from '../utils/textUtils';
import './ExperienceProject.css';

const ExperienceProject = ({ project, index }) => {
  const bulletPoints = convertToBulletPoints(project.description);
  const technologies = formatTechnologies(project.technologies);
  const dateRange = formatDateRange(project.start_date, project.end_date);

  return (
    <div className="experience-project" data-project-index={index}>
      <div className="project-header">
        <div className="project-title-section">
          <h4 className="project-title">
            {project.title}
          </h4>
        </div>
        {dateRange && (
          <div className="project-duration">
            <FaCalendarAlt className="duration-icon" />
            {dateRange}
          </div>
        )}
      </div>

      <div className="project-description">
        {bulletPoints.length > 1 ? (
          <ul className="project-bullet-points">
            {bulletPoints.map((point, i) => (
              <li key={i} className="bullet-point">
                {point}
              </li>
            ))}
          </ul>
        ) : (
          <p className="project-description-text">
            {bulletPoints[0] || project.description}
          </p>
        )}
      </div>

      {technologies.length > 0 && (
        <div className="project-technologies">
          <span className="tech-label">Technologies:</span>
          <div className="tech-badges">
            {technologies.map((tech, i) => (
              <span className="tech-badge project-tech" key={i}>
                {tech}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExperienceProject;
